import { render, staticRenderFns } from "./PasswordInput.vue?vue&type=template&id=5a4d65f9"
import script from "./PasswordInput.vue?vue&type=script&lang=ts"
export * from "./PasswordInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon})
